export default "__VITE_ASSET__yKfoq0Ue__"